
export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/523319882655"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 z-50 cursor-pointer"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </a>
  );
}
